import React, { useEffect, useMemo, useState } from "react";
import "./Hero.css";
import { FiArrowUpRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import heroVideo from "../../../../assets/videos/slider.MOV";
import { resolveMediaUrl } from "../../../../utils/media";

const defaultHero = {
  title: "Iraqi Leading Gypsum Manufacturing and Construction Solutions",
  servicesButtonText: "See our services",
  servicesButtonLink: "/services",
  productsButtonText: "See our products",
  productsButtonLink: "/products",
  introVideo: "",
};

const imageExtensionRegex = /\.(png|jpe?g|gif|webp|svg|avif|bmp)(\?.*)?$/i;
const videoExtensionRegex = /\.(mp4|mov|webm|avi|mkv|m4v)(\?.*)?$/i;
const imageHintRegex = /(image|img|photo|thumbnail|thumb|banner|logo|avatar|format=webp|format=jpg|format=jpeg|format=png)/i;
const videoHintRegex = /(video|clip|trailer|stream|m3u8)/i;

const getHeroMediaCandidate = (hero) => {
  if (!hero || typeof hero !== "object") return "";

  const candidates = [
    hero.introVideoMediaUrl,
    hero.introVideoUrl,
    hero.introVideoMedia,
    hero.mediaUrl,
    hero.introVideo,
  ];

  for (const candidate of candidates) {
    if (!candidate) continue;

    if (typeof candidate === "object") {
      const objectCandidate = candidate.mediaUrl || candidate.url || candidate.value || "";
      const resolvedObject = resolveMediaUrl(objectCandidate);
      if (resolvedObject) return resolvedObject;
      continue;
    }

    const resolved = resolveMediaUrl(candidate);
    if (resolved) return resolved;
  }

  return "";
};

const detectHeroMediaType = (src) => {
  const value = String(src || "");
  if (!value) return "video";
  if (videoExtensionRegex.test(value)) return "video";
  if (imageExtensionRegex.test(value)) return "image";
  if (videoHintRegex.test(value)) return "video";
  if (imageHintRegex.test(value)) return "image";
  return "video";
};

const hasSectionData = (section) => {
  if (!section || typeof section !== "object") return false;
  return Object.values(section).some((value) => {
    if (value === null || typeof value === "undefined") return false;
    if (typeof value === "string") return value.trim().length > 0;
    return true;
  });
};

const Hero = ({ content }) => {
  const navigate = useNavigate();
  const [hero, setHero] = useState(defaultHero);

  useEffect(() => {
    setHero(hasSectionData(content) ? content : defaultHero);
  }, [content]);

  const heroMedia = useMemo(() => {
    const dynamicSrc = getHeroMediaCandidate(hero);
    if (!dynamicSrc) {
      return { type: "video", src: heroVideo };
    }

    return { type: detectHeroMediaType(dynamicSrc), src: dynamicSrc };
  }, [hero]);

  return (
    <div className="hero">

      <div className="hero-bg">
        {heroMedia.type === "image" ? (
          <img className="hero-bgImage" src={heroMedia.src} alt="" aria-hidden="true" />
        ) : (
          <video
            className="hero-bgVideo"
            src={heroMedia.src}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            aria-hidden="true"
          />
        )}
        <div className="hero-overlay" aria-hidden="true" />
      </div>

      <div className="hero-content">
        <h1>{hero.title}</h1>

        <div className="hero-buttons">
          <button
            className="buttongyp"
            type="button"
            onClick={() => navigate(hero.servicesButtonLink || "/services")}
          >
            {hero.servicesButtonText} <FiArrowUpRight className="icon" />
          </button>

          <button
            className="btn-outline"
            type="button"
            onClick={() => navigate(hero.productsButtonLink || "/products")}
          >
            {hero.productsButtonText} <FiArrowUpRight className="icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
